import { useEffect, useState } from "react"

export const logOut = (setTokens, setUsername) => {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('username')
    setTokens(undefined)
    setUsername(undefined)
}

const Logout = (props) => {
    const [redirect, setRedirect] = useState(false)
    useEffect(()=>{
        logOut(props.setTokens, props.setUsername)
        setRedirect(true)
    },[props])
    if(redirect) {
        window.location.href = "../../"
        return null
    } else {
        return(<div>Please wait...</div>)
    }
}

export default Logout
